import React, { Fragment } from "react";
import { Card, Typography } from "antd";
import { DocumentTitle } from "../../components";
import I18n from "../../i18n";

const faqData: { question: string; answer: string }[] = [
  {
    question: "چگونه میتوانم سفارش خود را ثبت کنم؟",
    answer:
      "شما برای ثبت سفارش و خرید از فروشگاه اینترنتی بهارا برند پس از اینکه کالای مورد نظر را انتخاب کردید آن را به سبد خرید اضافه و به ترتیب مراحل خرید اینترنتی را تکمیل نمایید.",
  },
  {
    question:
      "آیا می توان بدون ثبت‌نام در سایت یا داشتن حساب کاربری، سفارش خود را ثبت نمایم؟",
    answer:
      "خیر، شما برای ثبت سفارش در فروشگاه اینترنتی بهارا‌ برند، حتما باید دارای حساب کاربری باشید. برای این کار بر روی قسمت ثبت‌نام در سایت کلیک کرده و حساب کاربری خود را بسازید. برای ساختن حساب کاربری به شماره تلفن همراه احتیاج خواهید داشت.",
  },
  {
    question: "چگونه می‌توانم قبل از ثبت سفارش از سایز انتخابی مطمئن شوم؟",
    answer:
      "برای هر محصول راهنمای سایز در صفحه همان محصول قرار گرفته است. در صورتی که محصولی دارای راهنمای سایز نبود لطفا به پشتیبانی اطلاع دهید.",
  },
  {
    question: "آیا می‌توانم بعد از ثبت سفارش آن را تغییر دهم یا کنسل کنم؟",
    answer: "خیر, متاسفانه پس از تایید نهایی سفارش امکان تغییر آن وجود ندارد.",
  },
  {
    question:
      "پس از اینکه سفارشم را ثبت کردم چقدر میزان طول خواهد کشید تا به دستم برسد؟",
    answer:
      "زمان رسیدن سفارش با توجه به عوامل مختلف می‌تواند متفاوت باشد. معمولا بین ۳ تا ۵ روز کاری محصولات تحویل داده می‌شوند.",
  },
  {
    question: "چگونه می‌توانم کدپستی مرسوله را ببینم؟",
    answer:
      "بعد از پست محصول کد مرسوله پستی در قسمت سفارش های شما قرار می‌گیرد.",
  },
];

export default function FAQ() {
  return (
    <DocumentTitle title={I18n.general.faq}>
      <Card
        style={{ margin: 32 }}
        title={
          <Typography.Title level={3}>{I18n.general.faq}</Typography.Title>
        }
      >
        {faqData.map((item) => (
          <Fragment>
            <Typography.Title level={5}>{item.question}</Typography.Title>
            <Typography.Paragraph>{item.answer}</Typography.Paragraph>
          </Fragment>
        ))}
      </Card>
    </DocumentTitle>
  );
}
